import { debounce } from "lodash-es";

export default {
  data() {
    return {
      isMobileViewport: this.$ui.isMobileView(),
    };
  },

  watch: {
    isMobileViewport(currentIsMobileViewport, prevIsMobileViewport) {
      if (
        (currentIsMobileViewport && !prevIsMobileViewport) ||
        (!currentIsMobileViewport && prevIsMobileViewport)
      ) {
        window.location.reload();
      }
    },
  },

  async mounted() {
    window.addEventListener("resize", this.windowOnResize);
    this.windowOnResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.windowOnResize);
  },

  methods: {
    windowOnResize: debounce(function debounceFunc() {
      this.isMobileViewport = this.$ui.isMobileView();
    }),
  },
};
